import React, { useState } from 'react';
import './Services.css';
import { servicesData } from '../data/servicesData';
import ServiceModal from './ServiceModal';

const Services = ({ currentLanguage, openModal }) => {
  const [selectedService, setSelectedService] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showServiceModal, setShowServiceModal] = useState(false);

  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'Divine Services',
        subtitle: 'Discover your cosmic blueprint through ancient wisdom',
        exploreService: 'Explore Service'
      },
      hi: {
        title: 'दिव्य सेवाएं',
        subtitle: 'प्राचीन ज्ञान के माध्यम से अपना ब्रह्मांडीय खाका खोजें',
        exploreService: 'सेवा देखें'
      },
      gu: {
        title: 'દિવ્ય સેવાઓ',
        subtitle: 'પ્રાચીન શાણપણ દ્વારા તમારો કોસ્મિક બ્લુપ્રિન્ટ શોધો',
        exploreService: 'સેવા જુઓ'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  const mainServices = [
    servicesData.vastu,
    servicesData.numerology,
    servicesData.astrology,
    servicesData.pooja,
    servicesData.consultation,
    servicesData.others
  ];

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setShowServiceModal(true);
  };

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
  };

  const closeServiceModal = () => {
    setShowServiceModal(false);
    setSelectedService(null);
    setSelectedLocation(null);
  };

  return (
    <>
      <section id="services" className="services">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{getTranslation('title')}</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle">{getTranslation('subtitle')}</p>
          </div>
          <div className="main-services-grid">
            {mainServices.map((service) => (
              <div 
                key={service.id}
                className="main-service-card" 
                onClick={() => handleServiceClick(service)}
              >
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <i className={service.icon}></i>
                  </div>
                  <div className="service-glow"></div>
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <button className="service-explore-btn">
                    {getTranslation('exploreService')}
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
                <div className="service-bg-pattern"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {showServiceModal && (
        <ServiceModal
          service={selectedService}
          location={selectedLocation}
          onLocationSelect={handleLocationSelect}
          onClose={closeServiceModal}
          currentLanguage={currentLanguage}
        />
      )}
    </>
  );
};

export default Services;